var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{class:['s-popup', _vm.positionClass, _vm.visibleClass, _vm.effectClass, _vm.customClass],style:(_vm.styleZindex + _vm.styleDuration)},[(_vm.mask)?[_c('v-uni-view',{staticClass:"s-popup-mask",style:('background-color: rgba(0, 0, 0, ' + _vm.maskOpacity + ');'),on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return e.preventDefault(); }).apply(void 0, arguments)
},"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
_vm.maskClose && _vm.hide()
}}})]:_vm._e(),(_vm.preventTouchmove)?_c('v-uni-view',{staticClass:"s-popup-wrapper",style:({
      backgroundColor: _vm.backgroundColor,
      borderRadius: _vm.round ? '40rpx 40rpx 0 0' : _vm.radius,
    }),on:{"touchmove":function($event){$event.stopPropagation();$event.preventDefault();
arguments[0] = $event = _vm.$handleEvent($event);
(function (e) { return e.preventDefault(); }).apply(void 0, arguments)
}}},[_vm._t("default")],2):_c('v-uni-view',{staticClass:"s-popup-wrapper",style:({
      backgroundColor: _vm.backgroundColor,
      borderRadius: _vm.round ? '40rpx 40rpx 0 0' : _vm.radius,
    })},[_vm._t("default")],2)],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }